import { ExternalCredentials } from '@por/shared/core';
import { Depot } from '../../../shared/models/depot.interface';

export interface OrganizationState {
    depots: Depot[];
    externalCredentials?: ExternalCredentials[];
}

export const organizationInitialState: OrganizationState = {
    depots: []
};
